<template>
    <div>
        <v-rating v-model="rating">
            <template #item="props">
                <v-btn
                    @click="props.click(props.index)"
                    :color="props.value - 1 == props.index ? 'primary' : ''"
                    icon
                    large
                >
                    <v-icon large>
                        <template v-if="props.value - 1 == props.index">
                            {{ filledIconMap[props.index] }} #}
                        </template>

                        <template v-else>
                            {{ iconMap[props.index] }} #}
                        </template>
                    </v-icon>
                </v-btn>
            </template>
        </v-rating>

        <skip-and-send-button @send="rate" @skip="$emit('skip')" :disabled="! rating"  />
    </div>
</template>

<script>
import SkipAndSendButton from './SkipAndSendButton.vue'

export default {
    components: {
        SkipAndSendButton
    },

    data: () => ({
        rating: null,
        iconMap: [
            'mdi-emoticon-cry-outline',
            'mdi-emoticon-sad-outline',
            'mdi-emoticon-neutral-outline',
            'mdi-emoticon-happy-outline',
            'mdi-emoticon-excited-outline'
        ],
        filledIconMap: [
            'mdi-emoticon-cry',
            'mdi-emoticon-sad',
            'mdi-emoticon-neutral',
            'mdi-emoticon-happy',
            'mdi-emoticon-excited'
        ]
    }),

    methods: {
        rate() {
            this.$emit('input', this.rating)
        }
    }
}
</script>
